module.exports = __webpack_public_path__ + "img/exercise_test-3.b42150c0.png";